import { all, takeLatest } from "redux-saga/effects";

import {
  FETCH_PEER_CONFIG_REQUEST,
  UPDATE_PEER_CONFIG_REQUEST,
} from "../../actions/peerEvaluationConfigActions";
import {
  fetchPeerConfigSaga,
  updatePeerConfigSaga,
} from "../../sagas/peerEvaluationConfigSaga";

import {
  FETCH_SKILL_PEER_INBOX_REQUEST,
  FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST,
  FETCH_SKILL_EVALS_BY_USER_REQUEST,
  CREATE_SKILL_EVAL_REQUEST,
  UPDATE_SKILL_EVAL_REQUEST,
  DELETE_SKILL_EVAL_REQUEST,
  SUBMIT_AUTO_EVAL_REQUEST,
  SKILL_MANAGER_DECISION_REQUEST,
  FETCH_SKILL_MANAGER_INBOX_REQUEST,
  FETCH_SKILL_RF_INBOX_REQUEST,
  FETCH_CONSOLIDATED_RESULTS_REQUEST,
  GENERATE_PEER_PROPOSALS_REQUEST,
  CONFIRM_PEER_ASSIGNMENTS_REQUEST,
} from "../../actions/skillEvaluationActions";
import {
  fetchSkillPeerInboxSaga,
  fetchSkillEvalsByCampagneSaga,
  fetchSkillEvalsByUserSaga,
  createSkillEvalSaga,
  updateSkillEvalSaga,
  deleteSkillEvalSaga,
  skillSubmitAutoEvalSaga,
  skillManagerDecisionSaga,
  skillRfDecisionSaga,
  fetchSkillManagerInboxSaga,
  fetchSkillRfInboxSaga,
  fetchConsolidatedResultsSaga,
  generatePeerProposalsSaga,
  confirmPeerAssignmentsSaga,
} from "../../sagas/skillEvaluationSaga";


import {
  FETCH_NIVEAU_SKILLS_REQUEST,
  CREATE_NIVEAU_SKILL_REQUEST,
  UPDATE_NIVEAU_SKILL_REQUEST,
  DELETE_NIVEAU_SKILL_REQUEST,
} from "../../actions/niveauSkillActions";
import {
  fetchNiveauSkillsSaga,
  createNiveauSkillSaga,
  updateNiveauSkillSaga,
  deleteNiveauSkillSaga,
} from "../../sagas/niveauSkillSaga";

import {
  FETCH_NIVEAU_CRITICITE_REQUEST,
  CREATE_NIVEAU_CRITICITE_REQUEST,
  UPDATE_NIVEAU_CRITICITE_REQUEST,
  DELETE_NIVEAU_CRITICITE_REQUEST,
} from "../../actions/niveauCriticiteActions";
import {
  fetchNiveauCriticiteSaga,
  createNiveauCriticiteSaga,
  updateNiveauCriticiteSaga,
  deleteNiveauCriticiteSaga,
} from "../../sagas/niveauCriticiteSaga";

import {
  FETCH_JOB_SKILLS_REQUEST,
  CREATE_JOB_SKILL_REQUEST,
  UPDATE_JOB_SKILL_REQUEST,
  DELETE_JOB_SKILL_REQUEST,
  IMPORT_JOB_SKILLS_EXCEL_REQUEST,
  DOWNLOAD_JOB_SKILLS_TEMPLATE_REQUEST,
} from "../../actions/jobSkillActions";
import {
  fetchJobSkillsSaga,
  createJobSkillSaga,
  updateJobSkillSaga,
  deleteJobSkillSaga,
  importJobSkillsExcelSaga,
  downloadJobSkillsTemplateSaga,
} from "../../sagas/jobSkillSaga";

import {
  FETCH_MODES_EVALUATION_REQUEST,
  CREATE_MODE_EVALUATION_REQUEST,
  UPDATE_MODE_EVALUATION_REQUEST,
  DELETE_MODE_EVALUATION_REQUEST,
} from "../../actions/modeEvaluationActions";
import {
  fetchModesEvaluationSaga,
  createModeEvaluationSaga,
  updateModeEvaluationSaga,
  deleteModeEvaluationSaga,
} from "../../sagas/modeEvaluationSaga";

import {
  FETCH_SKILLS_REQUEST,
  FETCH_SKILLS_BY_TYPE_REQUEST,
  CREATE_SKILL_REQUEST,
  UPDATE_SKILL_REQUEST,
  DELETE_SKILL_REQUEST,
  DOWNLOAD_SKILLS_TEMPLATE_REQUEST,
  IMPORT_SKILLS_EXCEL_REQUEST,
  EXPORT_SKILLS_REQUEST,
} from "../../actions/skillsActions";
import {
  fetchSkillsSaga,
  fetchSkillsByTypeSaga,
  createSkillSaga,
  updateSkillSaga,
  deleteSkillSaga,
  downloadSkillsTemplateSaga,
  importSkillsExcelSaga,
  exportSkillsSaga,
} from "../../sagas/skillsSaga";

import {
  GET_ALL_CAREER_PATHS_REQUEST,
  GET_ACTIVE_CAREER_PATHS_REQUEST,
  GET_CAREER_PATH_REQUEST,
  CREATE_CAREER_PATH_REQUEST,
  UPDATE_CAREER_PATH_REQUEST,
  DELETE_CAREER_PATH_REQUEST,
} from "../../actions/careerPathActions";
import {
  getAllCareerPathsSaga,
  getActiveCareerPathsSaga,
  getCareerPathSaga,
  createCareerPathSaga,
  updateCareerPathSaga,
  deleteCareerPathSaga,
} from "../../sagas/careerPathSaga";

import {
  ADD_STEP_REQUEST,
  DELETE_STEP_REQUEST,
  GET_STEP_REQUEST,
  GET_STEPS_BY_CAREER_PATH_REQUEST,
  UPDATE_STEP_REQUEST,
} from "../../actions/careerPathStepActions";
import {
  addStepSaga,
  deleteStepSaga,
  getStepSaga,
  getStepsByCareerPathSaga,
  updateStepSaga,
} from "../../sagas/careerPathStepSaga";

import {
  ASSIGN_CAREER_PATH_REQUEST,
  DELETE_EMPLOYEE_CAREER_PATH_REQUEST,
  GET_ALL_EMPLOYEE_CAREER_PATHS_REQUEST,
  GET_EMPLOYEE_CAREER_PATH_REQUEST,
  GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_REQUEST,
  UPDATE_EMPLOYEE_CAREER_PATH_REQUEST,
  UPDATE_EMPLOYEE_CAREER_PATH_STATUS_REQUEST,
} from "../../actions/employeeCareerPathActions";
import {
  assignCareerPathSaga,
  deleteEmployeeCareerPathSaga,
  getAllEmployeeCareerPathsSaga,
  getEmployeeCareerPathSaga,
  getEmployeeCareerPathsByEmployeeSaga,
  updateEmployeeCareerPathSaga,
  updateEmployeeCareerPathStatusSaga,
} from "../../sagas/employeeCareerPathSaga";

export default function* skillsRootSaga() {
  yield all([
    takeLatest(FETCH_PEER_CONFIG_REQUEST, fetchPeerConfigSaga),
    takeLatest(UPDATE_PEER_CONFIG_REQUEST, updatePeerConfigSaga),

    takeLatest(FETCH_SKILL_PEER_INBOX_REQUEST, fetchSkillPeerInboxSaga),

    takeLatest(FETCH_NIVEAU_SKILLS_REQUEST, fetchNiveauSkillsSaga),
    takeLatest(CREATE_NIVEAU_SKILL_REQUEST, createNiveauSkillSaga),
    takeLatest(UPDATE_NIVEAU_SKILL_REQUEST, updateNiveauSkillSaga),
    takeLatest(DELETE_NIVEAU_SKILL_REQUEST, deleteNiveauSkillSaga),

    takeLatest(FETCH_NIVEAU_CRITICITE_REQUEST, fetchNiveauCriticiteSaga),
    takeLatest(CREATE_NIVEAU_CRITICITE_REQUEST, createNiveauCriticiteSaga),
    takeLatest(UPDATE_NIVEAU_CRITICITE_REQUEST, updateNiveauCriticiteSaga),
    takeLatest(DELETE_NIVEAU_CRITICITE_REQUEST, deleteNiveauCriticiteSaga),

    takeLatest(FETCH_JOB_SKILLS_REQUEST, fetchJobSkillsSaga),
    takeLatest(CREATE_JOB_SKILL_REQUEST, createJobSkillSaga),
    takeLatest(UPDATE_JOB_SKILL_REQUEST, updateJobSkillSaga),
    takeLatest(DELETE_JOB_SKILL_REQUEST, deleteJobSkillSaga),
    takeLatest(IMPORT_JOB_SKILLS_EXCEL_REQUEST, importJobSkillsExcelSaga),
    takeLatest(DOWNLOAD_JOB_SKILLS_TEMPLATE_REQUEST, downloadJobSkillsTemplateSaga),
    takeLatest(FETCH_MODES_EVALUATION_REQUEST, fetchModesEvaluationSaga),
    takeLatest(CREATE_MODE_EVALUATION_REQUEST, createModeEvaluationSaga),
    takeLatest(UPDATE_MODE_EVALUATION_REQUEST, updateModeEvaluationSaga),
    takeLatest(DELETE_MODE_EVALUATION_REQUEST, deleteModeEvaluationSaga),
  ]);

  yield takeLatest(FETCH_SKILLS_REQUEST, fetchSkillsSaga);
  yield takeLatest(FETCH_SKILLS_BY_TYPE_REQUEST, fetchSkillsByTypeSaga);
  yield takeLatest(CREATE_SKILL_REQUEST, createSkillSaga);
  yield takeLatest(UPDATE_SKILL_REQUEST, updateSkillSaga);
  yield takeLatest(DELETE_SKILL_REQUEST, deleteSkillSaga);
  yield takeLatest(DOWNLOAD_SKILLS_TEMPLATE_REQUEST, downloadSkillsTemplateSaga);
  yield takeLatest(IMPORT_SKILLS_EXCEL_REQUEST, importSkillsExcelSaga);
  yield takeLatest(EXPORT_SKILLS_REQUEST, exportSkillsSaga);

  yield takeLatest(GET_ALL_CAREER_PATHS_REQUEST, getAllCareerPathsSaga);
  yield takeLatest(GET_ACTIVE_CAREER_PATHS_REQUEST, getActiveCareerPathsSaga);
  yield takeLatest(GET_CAREER_PATH_REQUEST, getCareerPathSaga);
  yield takeLatest(CREATE_CAREER_PATH_REQUEST, createCareerPathSaga);
  yield takeLatest(UPDATE_CAREER_PATH_REQUEST, updateCareerPathSaga);
  yield takeLatest(DELETE_CAREER_PATH_REQUEST, deleteCareerPathSaga);

  yield takeLatest(GET_STEPS_BY_CAREER_PATH_REQUEST, getStepsByCareerPathSaga);
  yield takeLatest(GET_STEP_REQUEST, getStepSaga);
  yield takeLatest(ADD_STEP_REQUEST, addStepSaga);
  yield takeLatest(UPDATE_STEP_REQUEST, updateStepSaga);
  yield takeLatest(DELETE_STEP_REQUEST, deleteStepSaga);

  yield takeLatest(GET_ALL_EMPLOYEE_CAREER_PATHS_REQUEST, getAllEmployeeCareerPathsSaga);
  yield takeLatest(GET_EMPLOYEE_CAREER_PATH_REQUEST, getEmployeeCareerPathSaga);
  yield takeLatest(GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_REQUEST, getEmployeeCareerPathsByEmployeeSaga);
  yield takeLatest(ASSIGN_CAREER_PATH_REQUEST, assignCareerPathSaga);
  yield takeLatest(UPDATE_EMPLOYEE_CAREER_PATH_REQUEST, updateEmployeeCareerPathSaga);
  yield takeLatest(UPDATE_EMPLOYEE_CAREER_PATH_STATUS_REQUEST, updateEmployeeCareerPathStatusSaga);
  yield takeLatest(DELETE_EMPLOYEE_CAREER_PATH_REQUEST, deleteEmployeeCareerPathSaga);

  yield takeLatest(FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST, fetchSkillEvalsByCampagneSaga);
  yield takeLatest(FETCH_SKILL_EVALS_BY_USER_REQUEST, fetchSkillEvalsByUserSaga);
  yield takeLatest(CREATE_SKILL_EVAL_REQUEST, createSkillEvalSaga);
  yield takeLatest(UPDATE_SKILL_EVAL_REQUEST, updateSkillEvalSaga);
  yield takeLatest(DELETE_SKILL_EVAL_REQUEST, deleteSkillEvalSaga);
  yield takeLatest(SUBMIT_AUTO_EVAL_REQUEST, skillSubmitAutoEvalSaga);
  yield takeLatest(SKILL_MANAGER_DECISION_REQUEST, skillManagerDecisionSaga);
  yield takeLatest(FETCH_SKILL_MANAGER_INBOX_REQUEST, fetchSkillManagerInboxSaga);
  yield takeLatest(FETCH_SKILL_RF_INBOX_REQUEST, fetchSkillRfInboxSaga);
  yield takeLatest(FETCH_CONSOLIDATED_RESULTS_REQUEST, fetchConsolidatedResultsSaga);
  yield takeLatest(GENERATE_PEER_PROPOSALS_REQUEST, generatePeerProposalsSaga);
  yield takeLatest(CONFIRM_PEER_ASSIGNMENTS_REQUEST, confirmPeerAssignmentsSaga);
}
